// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Joi from 'joi'

import { EntityConstants } from 'constants/index'
import { phoneNumberSchema } from 'helpers/phoneValidation.helpers'

const messages = {
  'string.base': 'Field must be a string',
  'string.email': 'Invalid email format',
  'string.max': `Field must be at most {#limit} characters`,
}

function validationSchema() {
  return Joi.object({
    firstName: Joi.string()
      .required()
      .max(EntityConstants.MAX_FIRST_NAME_LENGTH)
      .messages(messages),
    lastName: Joi.string().required().max(EntityConstants.MAX_FIRST_NAME_LENGTH).messages(messages),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .max(EntityConstants.MAX_ADDRESS_LENGTH)
      .messages(messages),
    telephoneNumber: phoneNumberSchema,
    isActive: Joi.boolean().allow(null, '').optional(),
    role: Joi.string().optional(),
  })
}

export default validationSchema
